window.utils = {

    events: {
        init: function() {
            // initialise event handlers
            this.listeners.click.copy_text();
            this.listeners.click.configure_popups();
        },

        listeners: {
            // add event handlers here, under the event type
            click: {
                copy_text: function() {
                    document.addEventListener(
                        'click',
                        async function (event) {
                            if (!event.target.matches('.copy-to-clipboard')) {
                                return;
                            }

                            let clickedElement = event.target;

                            await window.utils.content.copy(clickedElement);
                        }
                    );
                },

                configure_popups: function() {
                    // move all popups to start of page so that they overlay everything
                    const subscriptionPopups = document.querySelectorAll(".klira-popup")
                    subscriptionPopups.forEach(popup => {
                        document.body.insertAdjacentElement("afterbegin", popup)
                    })

                    // add openers
                    document.addEventListener(
                        'click',
                        async function (event) {
                            if (!event.target.matches('.klira-popup-opener')) {
                                return;
                            }

                            let clickedElement = event.target;

                            let popupSelector = clickedElement.dataset.popupSelector;

                            if (!popupSelector) {
                                console.error('Element has no popup selector data attribute', clickedElement);
                                return
                            }

                            let popup = document.querySelector(`${popupSelector}`)

                            if (!popup) {
                                // the element does not exist
                                return;
                            }

                            if (!popup.classList.contains('klira-popup')) {
                                // this isn't the popup wrapper, find the wrapper element and open that
                                popup = popup.closest('.klira-popup');

                                if (!popup) {
                                    // there is no klira-popup for this
                                    return;
                                }
                            }

                            console.log("Opening popup", popupSelector);

                            window.utils.content.show(popup, 'block');
                        }
                    );

                    // add closers
                    document.addEventListener(
                        'click',
                        async function (event) {
                            if (
                                !event.target.matches('.klira-popup-close') &&
                                !event.target.closest('.klira-popup-close')
                            ) {
                                return true;
                            }

                            let clickedElement = event.target;

                            let popup = clickedElement.closest('.klira-popup');

                            if (!popup) {
                                // the element does not exist
                                return;
                            }

                            window.utils.content.hide(popup);
                        }
                    );
                }
            }
        }
    },


    request: {
        get: async function(url) {
            // Default options are marked with *
            const response = await fetch(url, {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": wpApiSettings.nonce
                },
                redirect: "follow",
                referrerPolicy: "no-referrer",
            });

            return response.json();
        },
        post: async function(url, data = {}) {
            // Default options are marked with *
            const response = await fetch(url, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": wpApiSettings.nonce
                },
                redirect: "follow",
                referrerPolicy: "no-referrer",
                body: JSON.stringify(data),
            });

            return response.json();
        },
        params: {
            get(param) {
                const urlParams = new URLSearchParams(window.location.search)
                return urlParams.get(param)
            }
        }
    },
    // utilities for use on forms
    forms: {
        hasErrorMessage: function(field) {
            const existingErrorMessage = field.parentElement.querySelector('.elementor-message-danger')

            return !!existingErrorMessage;
        },
        addErrorMessage: function(message, field, removeAfterSeconds = null, removeExistingErrors = true) {
            if (!field) {
                console.error('Cannot add error message, field does not exist. Message was:', message);
                return;
            }

            // create new error message container
            const errorMessage = document.createElement('div')
            errorMessage.style.width = '100%'
            errorMessage.classList.add('elementor-message', 'elementor-message-danger', 'form-field-error')
            errorMessage.textContent = message;

            if (removeExistingErrors) {
                // remove existing error messages
                window.utils.forms.removeErrorMessage(field);
            }

            // add the new error message to the page
            field.parentElement.appendChild(errorMessage);

            if (removeAfterSeconds && removeExistingErrors) {
                setTimeout(
                    function() {
                        window.utils.forms.removeErrorMessage(field)
                    },
                    removeAfterSeconds * 1000
                );
            }
        },

        removeErrorMessage: function(field) {
            // remove existing error messages
            const existingErrorMessage = field.parentElement.querySelector('.elementor-message-danger')
            if (existingErrorMessage) {
                existingErrorMessage.remove()
            }
        },

        updateFieldAndTriggerChangeEvent: function(input, newValue) {
            input.value = newValue;

            // create and dispatch an event so the field is updated in checkout
            let event = new Event('change');
            input.dispatchEvent(event);
        },
    },

    // utilities for dates
    dates: {
        validate: function(dayEl, monthEl, yearEl) {
            let errors = false;

            if (!dayEl.value) {
                window.utils.forms.addErrorMessage('Please enter day', dayEl);
                errors = true;
            } else {
                window.utils.forms.removeErrorMessage(dayEl);
            }

            if (!monthEl.value) {
                window.utils.forms.addErrorMessage('Please enter month', monthEl);
                errors = true;
            } else {
                window.utils.forms.removeErrorMessage(monthEl);
            }

            if (!yearEl.value) {
                window.utils.forms.addErrorMessage('Please enter year', yearEl);
                errors = true;
            } else {
                window.utils.forms.removeErrorMessage(yearEl);
            }

            if (errors) {
                return false;
            }

            let day = parseInt(dayEl.value)
            let month = parseInt(monthEl.value)
            let year = parseInt(yearEl.value)

            let now = new Date();
            let ageIsh = now.getFullYear() - year;

            if (ageIsh > 100 || ageIsh < 17) {
                window.utils.forms.addErrorMessage('You must be 18+, please contact us on dermteam@klira.skin', yearEl);
                return false
            }

            if (month < 1 || month > 12) {
                window.utils.forms.addErrorMessage('Invalid month', monthEl);
                return false;
            }

            const daysInMonth = new Date(year, month, 0).getDate()
            if (day < 1 || day > daysInMonth) {
                window.utils.forms.addErrorMessage('Invalid day', dayEl);
                return false
            }

            // looks valid
            return true
        }
    },

    // animated components
    animations: {
        addLoadingSpinner: function(container) {
            // remove existing loaders
            window.utils.animations.removeLoadingSpinner(container);

            const loadingSpinner = document.createElement('div')
            loadingSpinner.classList.add('klira-loader')
            const loadingSpinnerBackground = document.createElement('div')
            loadingSpinnerBackground.classList.add('klira-loader-background');
            loadingSpinner.appendChild(loadingSpinnerBackground);
            const loadingSpinnerContent = document.createElement('div')
            loadingSpinnerContent.classList.add('klira-loader-content');
            loadingSpinner.appendChild(loadingSpinnerContent);

            // add the new loader to the container
            container.appendChild(loadingSpinner);
        },

        removeLoadingSpinner: function(container) {
            const existingLoadingSpinner = container.querySelector('.klira-loader')
            if (existingLoadingSpinner) {
                existingLoadingSpinner.remove()
            }
        }
    },
    screens: {
        clientWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    },
    cookies: {
        getCookieValue: function(name) {
            const cookieArr = document.cookie.split(';')

            for (let i = 0; i < cookieArr.length; i++) {
              const cookiePair = cookieArr[i].split('=')
              if (name === cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1])
              }
            }

            return ''
        },

        setCookieValue: function(name, value) {
            document.cookie = name + "=" + (value || "") + "; path=/";
        },

        removeCookie: function(name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }
    },
    debounce: function(callback, waitTime) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { callback(...args); }, waitTime);
        };
    },

    content: {
        copy: async function(copyElement) {
            try {
                console.log('copying');
                // pull the data from the clicked element
                let textValue = copyElement.dataset.copyText;

                if (!textValue) {
                    console.error('Attempting to copy but no text was specified', copyElement);
                    return;
                }

                await navigator.clipboard.writeText(textValue);

                let copiedText = copyElement.dataset.copiedLabel ?? 'Copied';
                let defaultText = copyElement.dataset.defaultLabel ?? 'Click to copy';

                copyElement.value = copiedText;
                setTimeout(() => {
                    copyElement.value = defaultText
                }, 2000)
            } catch (err) {
                console.error(err)
            }
        },

        hide: function(element) {
            if (!element) {
                return;
            }

            element.style.display = 'none'
        },
        show: function(element, displayStyle) {
            if (!element) {
                return;
            }

            if (displayStyle) {
                element.style.display = displayStyle;
            } else {
                element.style.removeProperty('display');
            }
        },

        isHidden: function(element) {
            let style = window.getComputedStyle(element);
            return (style.display === 'none')
        },
        isVisible: function(element) {
            return !this.isHidden(element);
        }
    },

    system: {
        isIOS: function() {
            return /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
        }
    }
}

// set up event listeners
window.utils.events.init();
